<template>
  <div class="page-content memberCenter" id="page-content" :style="'height: auto;background-color: #F3F5F7;padding: 0;box-shadow: none;' + defaultHeight">
    <div class="bgwhite pad20">
      <div class="startTitle">会员中心</div>
      <el-row class="pad">
        <el-col :span="3" class="tximgbox">
          <img class="tximg" :src="avatar" alt="">
        </el-col>
        <el-col :span="10" class="memberinfo">
          <h2>{{userName}}</h2>
          <img class="memberIMG" src='@/assets/images/hyuan1.png' v-if="vipForm.vipTime === '未开通'" />
          <img class="memberIMG" src='@/assets/images/hyuan2.png' v-else />
          <div>
            <!-- <div class="membertime" @click="toPage()" v-if="vipForm.vipTime === '未开通'">开通会员</div>
            <div class="membertime" @click="toPage2()" v-else>立即续费</div> -->
            <div class='membertimeS' v-if="vipForm.vipTime === '未开通'">未开通</div>
            <div class='membertimeS' v-else>会员有效期 {{vipForm.vipTime}}</div>
          </div>
        </el-col>
        <el-col :span="11" class="textR">
          <el-button type="danger" icon="el-icon-date" v-if="qiandaodType=='1'" @click="doSign()" class="signpast">已签到</el-button>
          <el-button type="danger" icon="el-icon-date" v-else @click="doSign()">立即签到</el-button>
          <div class="memberqd">签到领积分，已连续签到<span class="allCount">{{allCount}}</span>天</div>
        </el-col>
      </el-row>
    </div>
    <!-- 推广主 -->
    <el-row style="margin-top: 20px;">
      <el-col :span="15" class="padtb">
        <el-row>
          <el-col :span="7" class="line140 borR textCen">
            <el-button type="info" class="menbertgzBtn tg" style="cursor: none" v-if="vipForm.advertiserType==='1'">我是推广主</el-button>
            <el-button @click="toPage()" type="info" class="menbertgzBtn tg" style="cursor: pointer" v-else><span>立即推广</span></el-button>
          </el-col>
          <el-col :span="8" class="line140 tgzBox">
            <div class="tgzText">粉丝</div>
            <div class="tgznum">{{personalCenterForm.allFans}}</div>
            <div class="tgzbtn" @click="toPage()">粉丝明细</div>
          </el-col>
          <el-col :span="7" class="line140 tgzBox">
            <div class="tgzText">今日返利收益</div>
            <div class="tgznum">{{personalCenterForm.incomerecordTodayPrice}}</div>
            <div class="tgzbtn" @click="toPage()">收益明细</div>
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="9" class="jifenBox ">
        <div class="itemBox line180  padtb ">
          <img class="jifenimg inline-block" src="../../assets/images/back/jifenImg.png" alt="">
          <div class="tgzBox inline-block spadl">
            <div class="tgzText">我的积分</div>
            <div class="tgznum">{{userIntegral}} <span><i class="wenhao">?</i>积分说明</span></div>
            <div class="tgzbtn" @click="creditsExchang()">粉丝兑换</div>
          </div>
        </div>
      </el-col>
    </el-row>
    <!-- 商品模块 -->
    <div class="memberCard" style="margin-top: 20px;background-color: #ffffff">
      <el-row>
        <el-col :span="12" class="memberCardTit">
          <span @click="tabClick('year')" :class="type==='year'?'tabInline act':'tabInline'">会员充值
            <!-- 吾征会员卡 --></span>
          <!-- <span @click="tabClick('ci')" :class="type==='ci'?'tabInline act':'tabInline'">吾征次数体验卡</span> -->
        </el-col>
        <el-col :span="12" style="text-align: right">
          <el-button type="info" class="menbertgzBtn dmh-djbtn" style="margin-top: 0;" @click="dialogFormVisible = true">已有代金卡号</el-button>
        </el-col>
      </el-row>
      <div style="height: 20px"></div>
      <!-- 年卡 -->
      <el-row :gutter="24">
        <template v-for="(item,index) in combinationList">
          <el-col :key="index" :span="4">
            <div :class="item.defaultChoice==1?'yearBox act':'yearBox'" @click="xuanze(item.id,index)">
              <el-button type="success" round class="yearBoxBtn" style="margin-bottom: 10px;">{{item.instructions?'特惠充值':'体验套餐'}}</el-button>
              <h2>{{item.instructions?item.name:'健康智能分析报告'+item.name}}</h2>
              <!-- <span class="sm">{{item.describe}}</span> -->
              <div class="price"><span class="priceL"><i>￥</i>{{item.currentPrice}}</span><br><span class="priceR" style=" text-decoration: line-through;">{{item.price}}</span></div>
            </div>
          </el-col>
        </template>
      </el-row>
      <!-- 次卡 -->
      <!--  <el-row :gutter="24" v-show="type==='ci'">
        <template v-for="(item,index) in commodityTimeList">
          <el-col :key="index+'ci'" :span="6">
            <div :class="ci_index==index?'cicardBox act':'cicardBox'" @click="typeCLick(item,'ci',index)">
              <h2>{{commodityTimeName}}</h2>
              <div class="cishuNum">{{parseFloat(item.name)}}<span>/次</span></div>
              <div class="price">尊享价：<span>￥{{item.price}}</span></div>
            </div>
          </el-col>
        </template>
      </el-row> -->
      <div style="height: 20px;"></div>
      <!--  <div class="tcText" v-show="type==='year'">加选超值礼包套餐</div>
      <el-row class="tcList" v-show="type==='year'">
        <el-col :class="(index+1)%5===0?'mr0':''" :span="4" v-for="(item,index) in giftName" :key="'giftName'+index">
          <div :class="gift_index==index?'li act':'li'" @click="gift_click(index,item.id)">{{item.name}}</div>
        </el-col>
      </el-row> -->
      <div class="buynowBtn" @click="buynowBtn()">立即续签/立即购买</div>
    </div>
    <!--弹出代金号------开始    -->
    <el-dialog title="代金卡激活" :visible.sync="dialogFormVisible" style="padding: 30px;">
      <el-form :label-position="labelPosition">
        <el-divider></el-divider>
        <el-form-item label="激活码" :label-width="formLabelWidth">
          <el-input v-model="daijinNum" autocomplete="off" placeholder="请输入您的激活码"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="success" class="jihuobut" @click="jihuoCode()">立即激活码</el-button>
      </div>
    </el-dialog>
    <!--弹出代金号------结束    -->
    <!--   <el-dialog :visible.sync="open" width="644px" :show-close="false" style="line-height:1px;">
      <div class="codewrap">
        <img src="@/assets/images/weixin_coder.png">
        <p>扫码关注吾征AI公众号购买</p>
        <p></p>
      </div>
      <div class="codewrap">
        <img src="@/assets/images/app_coder.png">
        <p>扫码下载吾征AI健康 APP 购买</p>
        <p></p>
      </div>
      <div id="alertwarp">
        <div id="alertmask"></div>
        <div id="alertwx">
        </div>
      </div>
    </el-dialog> -->
    <el-dialog :visible.sync="open" width="1000px" :show-close="false" style="line-height:1px; text-align:center; margin-top:0; padding-top:0;">
      <img class='codewrapImg' src='@/assets/images/app_coder2.png' />
      <div class='codewrapdiv'>为了您更快捷全面的获取健康数据及更便捷的查看健康数据报告</div>
      <div class='codewrapdiv'>请您使用吾征AI健康APP或微信公众号体验健康服务</div>
      <div class='codewrapdiv2'>（扫描下方二维码下载安装APP或关注吾征AI微信公众号购买）</div>
      <div style='margin-bottom: 30px;'>
        <div class="codewrap">
          <img src="@/assets/images/app_coder.png">
          <p>吾征AI健康APP</p>
          <p>扫码下载</p>
        </div>
        <div class="codewrap">
          <img src="@/assets/images/weixin_coder.png">
          <p>吾征AI公众号</p>
          <p>扫码关注</p>
        </div>
      </div>
      <!-- 关注公众号 -->
      <div id="alertwarp">
        <div id="alertmask"></div>
        <div id="alertwx">
        </div>
      </div>
    </el-dialog>
    <!-- 弹出框 推广主 -->
    <el-dialog :visible.sync="open1" width="1000px" :show-close="false" style="line-height:1px; text-align:center; margin-top:0; padding-top:0;">
      <img class='codewrapImg' src='@/assets/images/app_coder2.png' />
      <div class='codewrapdiv'>即刻加入吾征AI,成为推广主，0投资、增收益，分享赚钱！</div>
      <div class='codewrapdiv'>请您使用吾征AI健康APP或微信公众号即刻获利</div>
      <div class='codewrapdiv2'>（扫描下方二维码下载安装APP或关注吾征AI微信公众号）</div>
      <div style='padding-bottom: 40px;'>
        <div class="codewrap2">
          <img src="@/assets/images/app_coder.png">
          <p>吾征AI健康APP</p>
          <p>扫码下载</p>
        </div>
        <div class="codewrap2">
          <img src="@/assets/images/weixin_coder.png">
          <p>吾征AI公众号</p>
          <p>扫码关注</p>
        </div>
      </div>
      <!-- 关注公众号 -->
      <div id="alertwarp">
        <div id="alertmask"></div>
        <div id="alertwx">
        </div>
      </div>
    </el-dialog>
    <!-- 弹出框 积分兑换 -->
    <el-dialog :visible.sync="open2" width="1000px" :show-close="false" style="line-height:1px; text-align:center; margin-top:0; padding-top:0;">
      <img class='codewrapImg' src='@/assets/images/app_coder2.png' />
      <div class='codewrapdiv'>为了您更便捷的使用积分兑换功能以及参与体验积分任务</div>
      <div class='codewrapdiv'>请您使用吾征AI健康APP或微信公众号获得更多积分奖励</div>
      <div class='codewrapdiv2'>（扫描下方二维码下载安装APP或关注吾征AI微信公众号）</div>
      <div style='padding-bottom: 40px;'>
        <div class="codewrap2">
          <img src="@/assets/images/app_coder.png">
          <p>吾征AI健康APP</p>
          <p>扫码下载</p>
        </div>
        <div class="codewrap2">
          <img src="@/assets/images/weixin_coder.png">
          <p>吾征AI公众号</p>
          <p>扫码关注</p>
        </div>
      </div>
      <!-- 关注公众号 -->
      <div id="alertwarp">
        <div id="alertmask"></div>
        <div id="alertwx">
        </div>
      </div>
    </el-dialog>
    <!-- 弹出框 充值会员 -->
    <el-dialog :visible.sync="open3" width="1000px" :show-close="false" style="line-height:1px; text-align:center; margin-top:0; padding-top:0;">
      <div class='hyuanH'>
        <div>吾征尊享会员</div>
        <img src='@/assets/images/X.png' />
      </div>
      <div class='hyuanH2'>
        <div class='hyuanH2a'>
          <div>体验套餐</div>
          <div>体验次数自充值之日起1年内有效</div>
        </div>
        <div class='hyuanH2a bianxie'>
          <div>特惠充值</div>
          <div>体验次数自充值之日起1年内有效</div>
        </div>
      </div>
      <div class='hyuanB'>
        <div class='hyuanT'>选择套餐</div>
        <div class='hyuanC' @click="dianji(0,10,20)">
          <div class='hyuanC1'>
            <div class='hyuanC1A'>20次体验套餐</div>
            <div class='hyuanC1B'>
              <span class='sC1B'>￥</span><span class='sC1B'>10.00</span>
              <del>￥20.00</del>
            </div>
            <div class='hyuanC1C'>健康智能分析报告20次</div>
          </div>
        </div>
        <div class='hyuanC' @click="dianji(1,20,50)">
          <div class='hyuanC1'>
            <div class='hyuanC1A'>50次体验套餐</div>
            <div class='hyuanC1B'>
              <span class='sC1B'>￥</span><span class='sC1B'>20.00</span>
              <del>￥50.00</del>
            </div>
            <div class='hyuanC1C'>健康智能分析报告50次</div>
          </div>
        </div>
        <div class='hyuanC' @click="dianji(2,30,100)">
          <div class='hyuanC1'>
            <div class='hyuanC1A'>100次体验套餐</div>
            <div class='hyuanC1B'>
              <span class='sC1B'>￥</span><span class='sC1B'>30.00</span>
              <del>￥100.00</del>
            </div>
            <div class='hyuanC1C'>健康智能分析报告100次</div>
          </div>
        </div>
        <div class='hyuanJ'>
          <span>支付方式</span>
          <div class='hyuanJ1'>
            <img src='@/assets/images/gwewm.png' />
          </div>
          <div class='hyuanJ2'>
            <div class='hyuanJ2A'>支付金额</div>
            <div class='hyuanC1B2' style='text-align:left;'>
              <span style='color: #FF6400;' class='yanse2'>{{qianM}}.00</span>
              <span class='yanse2' style='color: #666666FF;'>元</span>
              <del>￥{{qianMs}}.00</del>
            </div>
            <div class='hyuanCC'>
              <img src='@/assets/images/zfb.png' />
              <span>支付宝支付</span>
              <img src='@/assets/images/wx.png' />
              <span>微信支付</span>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>

<el-dialog title="支付方式" :visible.sync="dialogVisible" width="30%">
  <div style="margin: 20px 0;">
    <el-radio v-model="radio" label="2">微信</el-radio>
    <el-radio v-model="radio" label="1">支付宝</el-radio>
      
    </div>
      
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" style="width: 100px;height: 34px;">取 消</el-button>
        <el-button type="primary" @click="handleClose" style="width: 100px;height: 34px;">确 定</el-button>
      </span>
    </el-dialog>

    <div v-if="zhifu" class="ycbj">
      <div class="zhifus">
        <div class="title">
          微信支付
          <div class="xiaos" @click="quxiao()">x</div>
        </div>
        <img class="img1" src="@/assets/images/winsaoma.png">
        <!-- logoSrc为logo的url地址(使用require的方式)；text为需要转换为二维码的内容 :logoSrc="imageUrl"-->
        <vue-qr :text="wexindata.urlCode" :size="220" class="img2" style="display: block;"></vue-qr>
        <div class="d1">{{wexindata.orderNo}}</div>
        <div class="d2">支付:{{wexindata.orderPrice}}元</div>
      </div>
    </div>

     <div ref="alipayWap" v-html="alipay" ></div>



  </div>
</template>
<script>
import '@/assets/css/backcommon.css'
import { getCommodityList, getCommodityList1, personalCenter, vipCenter, signIntegral, creditsExchang, doSign } from '@/api/memberCenter'
import { request } from '@/network/request'
import vueQr from 'vue-qr'
export default {
  name: "memberCenter",
  components: {
    vueQr
  },
  data() {
    return {
      radio: '2',
      alipay:'',
      zhifu: false,
      wexindata: {},
      dialogVisible: false,
      row:{},
      // 弹出框
      open: false,
      open1: false,
      open2: false,
      open3: false,
      userName: "",
      avatar: "",
      labelPosition: "top",
      formLabelWidth: '70px',
      dialogFormVisible: false,
      daijinNum: "",
      defaultHeight: {
        height: ""
      },
      year_index: 0,
      ci_index: -1,
      gift_index: 0,
      year_id: '',
      gift_id: '',
      ci_id: '',
      type: "year",
      combinationList: '',
      combinationList1: '',
      commodityTimeName: "",
      commodityTimeList: "",
      giftName: '',
      allCount: "", //连续天数
      userIntegral: "", //用户积分
      qiandaodType: "", //是否签到
      serverType: "1",
      vipForm: {}, // 判断用户是否是推广主、会员
      personalCenterForm: {}, // 粉丝数量、收益明细
      qianM: 10, //充值多少钱的会员
      qianMs: 20, //打折之前多少钱的会员
    }
  },
  watch: {
    "$store.state.user.name": {
      handler(newVal, oldVal) {
        this.userName = newVal;
      },
      immediate: true
    },
    "$store.state.user.avatar": {
      handler(newVal, oldVal) {
        this.avatar = newVal;
      },
      immediate: true
    },
  },
  methods: {
    consumptionTimes (row) {
     
      let _this = this;
      _this.row = row;
      // 请求判断是否有消费次数
      request({
        //axios请求
        method: "post",
        url: "/api/pay/consumptionTimes",
        params: {
          //axios子组件qs封装data
          commodityId: row.id,
          userId: _this.$store.state.user.userId,
        },
      })
        .then(function (d) {
          console.log(d)
          if (d.data.code == '200') {
            _this.$message({
              message: '支付成功，稍等正在下载。',
              type: 'success'
            });


           

          } else if (d.data.code == 401) {
            _this.dialogVisible = false;
            ELEMENT.MessageBox.confirm(
              '登录状态已过期，您可以继续留在该页面，或者重新登录',
              '系统提示', {
              confirmButtonText: '重新登录',
              cancelButtonText: '取消',
              type: 'warning'
            }
            ).then(() => {
              _this.$router.push('/login');
            })
          } else if (d.data.code == 1) {
            _this.dialogVisible = true;
          }

        })
    },
        quxiao () {
      var _this = this;
      _this.zhifu = false;
      _this.websock.close();
    },
        handleClose () {
      let _this = this;
      _this.dialogVisible = false;
      _this.createOrder();

    },
    createOrder () {
      let _this = this;
      // 请求判断是否有消费次数
     request({
        //axios请求
        method: "post",
        url: "/api/pay/createOrder",
        params: {
          //axios子组件qs封装data
          commodityId: _this.row.id,
          userId: _this.$store.state.user.userId,
        },
      })
        .then(function (d) {
          if (d.data.code == '200') {

            if (_this.radio == 1) {
              _this.pcwz(_this.radio, 'http://' + window.location.host + _this.$route.path, d.data.msg);
            } else {
              _this.pcwz(_this.radio, '', d.data.msg);
            }
            _this.dds = d.data.msg;
          } else if (d.data.code == 401) {
            _this.dialogVisible = false;
            ELEMENT.MessageBox.confirm(
              '登录状态已过期，您可以继续留在该页面，或者重新登录',
              '系统提示', {
              confirmButtonText: '重新登录',
              cancelButtonText: '取消',
              type: 'warning'
            }
            ).then(() => {
              _this.$router.push('/login');
            })
          }

        })
    },
    pcwz (payMode, returnUrl, orderId) {
      let _this = this;
      request({
        //axios请求
        method: "post",
        url: "/api/pay/payByOrderId",
        params: {
          //axios子组件qs封装data
          orderId: orderId,
          userId: _this.$store.state.user.userId,
          payMode: payMode,
          returnUrl: returnUrl
        },
      })
        .then(function (d) {
          if (d.data.code == '200') {
            if (payMode == 1) {
              // _this.html = d.data.data.urlCode;
              // const div = document.createElement('divform');
              // div.innerHTML = _this.html;
              // document.body.appendChild(div);
              // document.forms[0].acceptCharset = 'UTF-8';
              // setTimeout(function () {
              //   document.forms[0].submit();
              // }, 1000)
              _this.alipay = d.data.data.urlCode;
               _this.$nextTick(() => {
                            // 提交支付表单
                            _this.$refs.alipayWap.children[0].setAttribute('target', '_blank')
                            _this.$refs.alipayWap.children[0].submit();
                            setTimeout(() => {
                              _this.initWebSocket();
                            }, 500);

                              });
            } else {

              _this.wexindata = d.data.data;
              _this.zhifu = true;
              _this.initWebSocket();

            }

          } else if (d.data.code == 401) {
            _this.dialogVisible = false;
            ELEMENT.MessageBox.confirm(
              '登录状态已过期，您可以继续留在该页面，或者重新登录',
              '系统提示', {
              confirmButtonText: '重新登录',
              cancelButtonText: '取消',
              type: 'warning'
            }
            ).then(() => {
              _this.$router.push('/login');
            })
          }

        })

    },
    initWebSocket () { //初始化weosocket
      // var timestamp = Date.parse(new Date());
      const wsuri = "ws://tj.wuzhengai.com/websocket/" + this.dds;
      // const wsuri = "ws://172.16.10.26:8092/api/websocket/www";
      this.websock = new WebSocket(wsuri);
      this.websock.onmessage = this.websocketonmessage;
      this.websock.onopen = this.websocketonopen;
      this.websock.onerror = this.websocketonerror;
      this.websock.onclose = this.websocketclose;
    },
    websocketonopen () { //连接建立之后执行send方法发送数据

      let actions = { "outTradeNo": ''};
      this.websocketsend(JSON.stringify(actions));
    },
    websocketonerror () {//连接建立失败重连
      this.initWebSocket();
    },
    websocketonmessage (e) { //数据接收
      const redata = JSON.parse(e.data);
      this.zhifu = false;
      this.consumptionTimes();
      console.log('连接', redata)

      this.websock.close();
    },
    websocketsend (Data) {//数据发送
      console.log('数据发送', Data)
      this.websock.send(Data);
    },
    websocketclose (e) {  //关闭
      console.log('断开连接', e);
    },
    
    xuanze(id, index) {
      let _this = this;
      for (let i = 0; i < _this.combinationList.length; i++) {
        _this.combinationList[i].defaultChoice = 0;

      }
      _this.combinationList[index].defaultChoice = 1;

    },
    //定义方法，获取高度减去头尾
    getHeight() {
      this.defaultHeight.height = document.getElementById("page-content") - 146 + "px";
    },
    // 会员码激活
    jihuoCode() {
      dialogFormVisible = false
    },
    // 立即续签/立即购买
    buynowBtn() {
      //入参
      let _this = this;
       for (let i = 0; i < _this.combinationList.length; i++) {
        if(_this.combinationList[i].defaultChoice==1){
                _this.consumptionTimes(_this.combinationList[i]);
        }

      }
      
      
      //this.open = true;
      /*console.log("会员卡 year_id", this.year_id);
      console.log("会员卡 gift_id", this.gift_id);
      console.log("次数卡 ci_id", this.ci_id);*/
    },
    // 会员卡/次卡切换
    tabClick(type) {
      this.type = type;
      if (type === "year") {
        this.year_index = 0;
        this.gift_index = 0;
        this.giftName = this.combinationList[0].giftName
        this.year_id = this.combinationList[0].id;
        this.gift_id = this.combinationList[0].giftName[0].id;
        this.ci_id = '';
      } else {
        this.ci_index = 0;
        this.year_id = '';
        this.gift_id = '';
        this.ci_id = this.commodityTimeList[0].id;
      }
    },
    getCommodityList() {
      let _this = this;
      getCommodityList({}).then(res => {
        if (parseFloat(res.data.code) == 200) {
          let arr = [];
          arr = res.data.data.combinationList;
          /*this.commodityTimeName = res.data.data.commodityTimeList[0].name;
          this.commodityTimeList = res.data.data.commodityTimeList[0].giftName;
          this.giftName = res.data.data.combinationList[0].giftName;
          this.year_id = res.data.data.combinationList[0].id;
          this.gift_id = res.data.data.combinationList[0].giftName[0].id;
          let arr3 = arr1.concat(arr2);*/
          // getCommodityList1({ 'vipType': 1 }).then(res => {
          //   if (parseFloat(res.data.code) == 200) {
          //     for (let i = 0; i < res.data.data.commodityTimeList[0].giftName.length; i++) {
          //       arr.push({
          //         currentPrice: res.data.data.commodityTimeList[0].giftName[i].price,
          //         defaultChoice: 0,
          //         id: res.data.data.commodityTimeList[0].giftName[i].id,
          //         img: res.data.data.commodityTimeList[0].giftName[i].img,
          //         name: res.data.data.commodityTimeList[0].giftName[i].name,
          //         price: res.data.data.commodityTimeList[0].giftName[i].falsePrice
          //       });

          //     }
          //     _this.combinationList = arr;

          //   }

          // });
          _this.combinationList = arr;

        }
      });



    },
    // 判断用户是否是会员、是否是推广主
    vipCenter() {
      vipCenter().then(res => {
        this.vipForm = res.data.data;
      })
    },
    // 个人中心：粉丝数量、今日收益
    getPersonalCenter() {
      personalCenter().then(res => {
        this.personalCenterForm = res.data.data;
      })
    },
    // 年会员和半年切换
    typeCLick(item, type, index) {
      if (type === 'year') {
        this.type = "year";
        this.giftName = item.giftName;
        this.year_id = item.id;
        this.gift_id = item.giftName[0].id;
        this.gift_index = 0;
        this.year_index = index;
        this.ci_index = -1;
        this.ci_id = '';
        return;
      }
      this.type = "ci";
      this.giftName = '';
      this.year_id = '';
      this.gift_id = '';
      this.ci_id = item.id;
      this.gift_index = 0;
      this.year_index = -1;
      this.ci_index = index;
    },
    // 加选超值礼包套餐
    gift_click(index, id) {
      this.gift_index = index;
      this.gift_id = id;
    },
    // 获取联续签到天数、积分等
    signIntegral() {
      var ths = this;
      signIntegral({}).then(res => {
        if (res.data.code == 200) {
          ths.allCount = res.data.data.allCount;
          ths.userIntegral = res.data.data.userIntegral;
          ths.qiandaodType = res.data.data.type;
        }
      })
    },
    // 积分兑换
    creditsExchang() {
      this.open2 = true;
      /*creditsExchang({ "serverType": this.serverType }).then(res => {
        var str = '';
        if (res.data.code == 200) {
          if (res.data.data == 1) {
            str = "积分不足";
          } else {
            str = "兑换成功";
          }
          this.message(str);
        }
      })*/
    },
    // 签到
    doSign() {
      var ths = this;
      ths.$router.push('/personCenter/memberCenter/signrecord');
      doSign({}).then(res => {
        if (res.data.code == 200) {
          if (res.data.data.signState == 0) {
            ths.allCount = res.data.data.allCount;
            ths.qiandaodType = 1;
          }
          this.message(res.data.data.signMessage)

        }
      });
    }
    //弹出推广主
    ,
    toPage() {
      this.open1 = true;
    }
    //弹出充值会员
    ,
    toPage2() {

      this.open3 = false;

    },
    //选中套餐 sC1B yanse hyuanC1C yanses
    dianji(n, q, z) {
      let _this = this;
      let a = document.getElementsByClassName('sC1B');
      let a1 = document.getElementsByClassName('hyuanC1C');
      _this.qianM = q;
      _this.qianMs = z;
      for (let b = 0; b < a.length; b++) {
        a[b].className = 'sC1B';
      }
      for (let b1 = 0; b1 < a1.length; b1++) {
        a1[b1].className = 'hyuanC1C';
      }
      if (n == 0) {
        a[0].className = 'sC1B yanse';
        a[1].className = 'sC1B yanse';
        a1[0].className = 'hyuanC1C yanses';
      } else if (n == 1) {
        a[2].className = 'sC1B yanse';
        a[3].className = 'sC1B yanse';
        a1[1].className = 'hyuanC1C yanses';
      } else if (n == 2) {
        a[4].className = 'sC1B yanse';
        a[5].className = 'sC1B yanse';
        a1[2].className = 'hyuanC1C yanses';
      }
    }


  },
  mounted() {
    //页面创建时执行一次getHeight进行赋值，顺道绑定resize事件
    window.addEventListener("resize", this.getHeight);
    this.getHeight();
    this.getCommodityList();
    this.vipCenter();
    this.signIntegral();
    this.getPersonalCenter();

  }

}

</script>
<style>
.daiJ1_28 {
  background: #E6E6E6FF;
  height: 1px;
}

.el-dialog__headerbtn .el-dialog__close {
  font-size: 20px;
  color: #000000;
  font-weight: bolder;
}

.el-dialog {
  padding: 30px 40px;
}

.el-dialog__headerbtn {
  top: 30px;
  right: 40px;
}

.dialog-footer .el-button {
  width: 150px;
  height: 50px;
  /* line-height: 50px; */
}

.dialog-footer .el-button span {

 /* font-size: 16px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #FFFFFF;*/
}

.hyuanJ {
  padding: 30px 0;
  height: 188px;
  width: 100%;
  background: #FFFFFF;
  border: 1px solid #e6e6e6;
  clear: both;
  text-align: center;
  display: flex;
  justify-content: center;
  align-content: center;
}

.hyuanCC img {
  margin-right: 11px;
  width: 24px;
  height: 24px;
}

.hyuanCC span {
  margin-right: 29px;
  line-height: 24px;
}

.hyuanJ>span {
  display: inline-block;
  position: relative;
  top: 55px;
  font-size: 15px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #000000;
  line-height: 15px;

}

.hyuanJ2A {
  font-size: 15px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 15px;
  text-align: left;
}

.hyuanJ2 {
  display: inline-block;
  position: relative;
  padding-top: 12px;
}

.hyuanJ1 {
  display: inline-block;
  width: 128px;
  height: 128px;
  background: #FFFFFF;
  border: 1px solid #E6E6E6;
  padding-top: 9.5px;
  margin: 0 20px;
  clear: both;
}

.hyuanJ1>img {
  width: 109px;
  height: 109px;

}

.hyuanB {
  height: 600px;
  margin-top: 18px;
  padding: 0 50px;
  box-sizing: border-box;
}

.hyuanT {
  text-align: left;
  font-size: 15px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #000000;
  line-height: 15px;
}

.hyuanC {
  width: 284px;
  float: left;
  background: #FFFFFF;
  border: 1px solid #FFD0B2;
  margin: 20px 0;
  margin-right: 23px;
}

.hyuanC:nth-child(4) {
  margin-right: 0;
}

.hyuanC1B {
  margin: 19px 0;
  text-align: center;
}

.hyuanC1B del {
  margin-left: 18px;
  font-size: 15px;
  font-family: PingFang SC;
  font-weight: 400;
  text-decoration: line-through;
  color: #999999;
  line-height: 15px;
}

.hyuanC1 .hyuanC1B .yanse {
  color: #FF6400;
}

.hyuanC1B span:nth-child(2) {
  font-size: 24px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #000000;
  line-height: 24px;
}

.hyuanC1B span:nth-child(1) {

  font-size: 15px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #000000;
  line-height: 15px;
}

.hyuanC1B2 {
  margin: 19px 0;
  text-align: center;
}

.hyuanC1B2 del {
  margin-left: 18px;
  font-size: 15px;
  font-family: PingFang SC;
  font-weight: 400;
  text-decoration: line-through;
  color: #999999;
  line-height: 15px;
}

.hyuanC1 .hyuanC1B2 .yanse2 {
  color: #FF6400;
}

.hyuanC1B2 span:nth-child(1) {
  font-size: 24px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #000000;
  line-height: 24px;
}

.hyuanC1B2 span:nth-child(2) {

  font-size: 15px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #000000;
  line-height: 15px;
}

.hyuanH2 {
  width: 100%;
}

.hyuanC1A {
  margin-top: 19px;
  font-size: 15px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #000000;
  line-height: 15px;
}

.hyuanC1C {
  padding: 8px 0;
  font-size: 15px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #FF6400;
  background: #FFEFE5;
  line-height: 15px;
}

.yanses {
  background: #FF6400;
  color: #FFFFFF;
}

.hyuanH2a {
  float: left;
  text-align: center;
  width: 50%;
  overflow: hidden;
  line-height: 18px;
}

.hyuanH2a div:nth-child(1) {
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #000000;
  margin-top: 20px;
  margin-bottom: 10px;
  line-height: 18px;
}

.bianxie {
  background: #F0F0F0;
}

.hyuanH2a div:nth-child(2) {
  font-size: 15px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #999999;
  margin-bottom: 19px;
  line-height: 15px;
}

.el-dialog__header {
  padding: 0;
}

.memberCenter .el-dialog__body {

  padding: 0;
}

.hyuanH {
  padding: 20px 50px;
  background: #596781;
  overflow: hidden;
}

.hyuanH div {
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #FFFFFF;
  float: left;
  margin-top: 11px;
}

.hyuanH img {
  width: 24px;
  height: 24px;
  float: right;
}

.memberIMG {
  margin-left: 14px;
  width: 24px;
  height: 24px;
}

.membertimeS {
  display: inline-block;
  font-size: 15px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #999999;
}

.memberCenter .el-dialog__header {
  border: none;
}

.el-dialog__body {
  padding-top: 0;
}

.codewrap2 {
  display: inline-block;
  width: 100px;
  margin-right: 70px;
  margin-left: 70px;
  text-align: center;
}

.codewrap2 img {
  padding-bottom: 10px;
  /* margin-top: 40px; */
}

.codewrap2 p {
  width: 100%;
  height: 22px;
  line-height: 22px;
  /* margin-bottom: 20px; */
}

.codewrapImg {

  width: 128px;
  height: 128px;
  margin-bottom: 50px;
  margin-top: 30px;
}

.codewrapdiv {
  height: 15px;
  color: #000000;
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 15px;
}

.codewrapdiv2 {
  height: 15px;
  color: #666;
  font-size: 15px;
  font-weight: 400;
  margin-bottom: 45px;
}

.codewrap {
  display: inline-block;
  width: 100px;
  margin-right: 70px;
  margin-left: 70px;
  text-align: center;
}

.codewrap img {
  padding-bottom: 10px;
  margin-top: 40px;
}

.codewrap p {
  width: 100%;
  height: 22px;
  line-height: 22px;
  margin-bottom: 20px;
}

.tcList .el-col.mr0 {
  margin-right: 0;
}

.bgwhite {
  background-color: #ffffff;
}

.mt20 {
  margin-top: 20px;
}

.pad20 {
  padding: 20px;
  padding-bottom: 15px;
}

.pad {
  background-color: #ffffff;
  padding-top: 10px;
  padding-bottom: 10px;
}

.memberCenter .padtb {
  background-color: #ffffff;
  padding-top: 20px;
  padding-bottom: 20px;
}

.bor {
  border: 1px solid red;
}

.borR {
  border-right: 1px solid #e5e5e5;
}

.line140 {
  height: 140px;
}

.line180 {
  height: 180px;
}

.line1 {
  line-height: 1;
}

.textCen {
  text-align: center;
}

.memberCenter .tximg {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  display: block;
  margin: 10px auto;
}

.memberCenter .memberinfo {
  padding: 10px;
  margin-top: 10px;
}

.memberCenter .memberinfo h2 {
  margin: 0;
  display: inline-block;
  font-size: 30px;
  font-weight: bold;
  color: rgba(0, 0, 0, 1);
}

.memberCenter .memberinfo .memberType {
  display: inline-block;
  font-size: 12px;
  font-weight: 400;
  color: #b4b4b4;
  background-color: #f4f4f4;
  border: 1px solid #b4b4b4;
  padding: 3px 5px;
  margin-left: 10px;
}

.memberCenter .memberinfo .membertime {
  display: inline-block;
  width: 80px;
  height: 30px;
  background: #14C86C;
  text-align: center;
  padding: 5px 0;
  border-radius: 5px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #FFFFFF;
  margin-right: 15px;
}

.memberCenter .memberqd {
  font-size: 13px;
  color: #999999;
  line-height: 30px;
  position: relative;
  top: 10px;
}

.memberCenter .el-button {
  padding: 10px 16px;
  /*font-size: 15px;*/
}

.textR {
  padding-top: 20px;
  text-align: right;
}

.menbertgzBtn {
  background-color: #02335e;
  font-size: 15px !important;
  margin-top: 50px;
}

.menbertgzBtn.tg {
  padding: 0 25px;
  height: 40px;
  line-height: 40px;
  margin-top: 50px;
  background: #596880;
  border-color: #596880;
  font-size: 14px !important;
}

.menbertgzBtn.tg:hover {
  opacity: 0.9;
}

.dmh-djbtn {
  background: #596880;
  border-color: #596880;
}

.dmh-djbtn:hover {
  background: #596880;
  border-color: #596880;
  opacity: 0.9;
}

.memberCenter .tgzBox {
  padding-left: 60px;
  padding-top: 10px;
}

.memberCenter .tgzBox .tgzText {
  line-height: 35px;
  font-size: 14px;
  font-weight: 400;
  color: rgba(0, 0, 0, 1);
}

.memberCenter .tgzBox .tgznum {
  font-size: 25px;
  font-weight: 800;
  color: rgba(51, 51, 51, 1);
  margin-bottom: 10px;
}

.memberCenter .tgzBox .tgznum span {
  font-size: 12px;
  color: #656565;
  /* line-height: 15px; */
  display: inline-block;
  margin-left: 20px;
  margin-top: -10px;
  position: relative;
  top: -7px;
}

.memberCenter .tgzBox .tgznum .wenhao {
  width: 16px;
  height: 16px;
  line-height: 16px;
  font-size: 12px;
  color: #ff5353;
  border: 1px solid #ff5353;
  border-radius: 50%;
  display: inline-block;
  text-align: center;
  margin-right: 5px;
  padding-bottom: 3px;
  vertical-align: bottom;
}

.memberCenter .tgzBox .tgzbtn {
  color: #ffffff;
  background-color: #13c76b;
  padding: 3px 12px;
  display: block;
  width: 100px;
  line-height: 25px;
  text-align: center;
  font-size: 14px;
  cursor: pointer;
}

.jifenBox .itemBox {
  margin-left: 25px;
  padding-left: 60px;
  padding-right: 60px;
  /*border: 1px solid blue;*/
}

.jifenBox .jifenimg {
  width: 70px;
  height: 80px;
  margin-top: 30px;
}

.inline-block {
  display: inline-block;
}

.inline-block.spadl {
  padding-left: 25px;
}

.memberCard {
  padding: 10px 20px 40px;
}

.memberCardTit span {
  line-height: 37px;
  display: block;
  font-size: 16px;
  font-weight: 500;
  color: rgba(153, 153, 153, 1);
}

.bg-purple {
  background: #d3dce6;
}

.bg-purple-light {
  background: #e5e9f2;
}

/*  会员卡*/

.memberCenter .yearBox {
  cursor: pointer;
  border: 1px solid #f4f4f4;
  margin-right: 10px;
  padding-top: 10px;
  height: 145px;
  padding-bottom: 10px;
}

.memberCenter .yearBox h2 {
  text-align: center;
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 5px;
  color: rgba(0, 0, 0, 1);
}

.memberCenter .yearBox .price {
  line-height: 30px;
  text-align: center;
  margin-top: 3px;
}

.memberCenter .yearBox .price .priceL {
  color: #13c76b;
  font-size: 26px;
  font-weight: bold;
}

.memberCenter .yearBox .price .priceR {
  font-size: 13px;
  font-weight: 400;
  color: #656565;
  /*margin-left: 20px;*/
}

.memberCenter .yearBox .sm {
  display: block;
  text-align: center;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  height: 18px;
  color: rgba(101, 101, 101, 1);
}

.memberCenter .yearBox .price .priceL i {
  color: #13c76b;
  font-size: 14px;
  font-weight: 400;
  color: rgba(19, 199, 107, 1);
}

.memberCenter .yearBox .yearBoxBtn {
  display: block;
  margin: 5px auto 0px;
  padding: 4px 10px;
  font-size: 14px;
  background-color: #14c86c;
}

.memberCenter .yearBox.act {
  border: 1px solid #ff5454;
  background-color: rgba(255, 84, 84, 0.06);
}

.memberCenter .yearBox.act .price .priceL i {
  /* color: #ff5454;*/
}

.memberCenter .yearBox.act .yearBoxBtn {
  /*  background-color: #ff5454;
  border-color: #ff5454;*/
}

.memberCenter .yearBox.act .price .priceL {
  /*  color: #ff5454;*/
}

.memberCenter .cicardBox {
  cursor: pointer;
  border: 1px solid #f4f4f4;
  margin-right: 10px;
  padding-top: 18px;
  height: 136px;
  padding-bottom: 18px;
  text-align: center;
}

.memberCenter .cicardBox h2 {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 5px;
  color: rgba(0, 0, 0, 1);
}

.memberCenter .cicardBox .cishuNum {
  font-size: 32px;
  font-weight: bold;
  color: rgba(0, 0, 0, 1);
  margin-bottom: 10px;
}

.memberCenter .cicardBox .cishuNum span {
  font-size: 18px;
  font-weight: bold;
  color: rgba(0, 0, 0, 1);
}

.memberCenter .cicardBox .price {
  font-size: 14px;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
}

.memberCenter .cicardBox span {
  font-size: 14px;
  font-weight: 400;
  color: #14c86c;
}

.memberCenter .cicardBox.act {
  cursor: pointer;
  border: 1px solid #ff5454;
  background-color: rgba(255, 84, 84, 0.06);
}

.memberCenter .cicardBox.act .price span {
  color: #ff5454;
}

.tcText {
  line-height: 50px;
  font-size: 15px;
  color: rgba(153, 153, 153, 1);
}

.tcList {
  overflow: hidden;
}

.tcList .el-col {
  margin-right: 20px;
}

.tcList .li {
  cursor: pointer;
  float: left;
  width: 180px;
  font-weight: 600;
  margin-bottom: 23px;
  height: 70px;
  padding-top: 17px;
  padding-left: 10px;
  padding-right: 10px;
  font-size: 13px;
  text-align: center;
  background: #fdfdfd;
  border: 1px solid #eeeeee;
}

.tcList .li.act {
  cursor: pointer;
  border: 1px solid #ff5454;
  background-color: rgba(255, 84, 84, 0.06);
}

.buynowBtn {
  cursor: pointer;
  color: #ffffff;
  background-color: #13c76b;
  padding: 3px 12px;
  display: block;
  width: 163px;
  line-height: 36px;
  text-align: center;
  font-size: 14px;
  margin: 20px auto;
  border-radius: 4px;
}

.allCount {
  color: #ff5454;
  padding-left: 3px;
  padding-right: 3px;
}

.tabInline {
  display: inline-block !important;
  cursor: pointer;
  margin-right: 30px;
  font-size: 13px;
}

.tabInline.act {
  font-size: 18px;
  color: #333333;
  font-weight: 600;
}

.signpast {
  background: #c8c8c8 !important;
  border-color: #c8c8c8 !important;
}
/* 支付弹出 */
.ycbj {
  width: 100%;
  height: 100vh;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: auto;
  margin: 0;
  z-index: 2009;
  background-color: rgba(0, 0, 0, 0.5);
}
.zhifus {
  width: 50%;
  position: relative;
  margin: 0 auto 50px;
  margin-top: 15vh;
  border-radius: 2px;
  -webkit-box-shadow: 0 1px 3px rgb(0 0 0 / 30%);
  box-shadow: 0 1px 3px rgb(0 0 0 / 30%);
  box-sizing: border-box;
  background-color: #fff;
}
.zhifus .title {
  position: relative;
  padding: 20px 20px 10px;
  text-align: center;
}
.zhifus .xiaos {
  position: absolute;
  top: 4px;
  right: 20px;
  font-size: 30px;
  color: #909399;
  cursor: pointer;
}
.zhifus .img1 {
  display: block;
  margin: auto;
  width: 220px;
  height: 66px;
  /*padding-top: 30px;*/
}
.zhifus .img2 {
  display: block;
  margin: auto;
  width: 220px;
  height: 220px;
}
.zhifus .d1 {
  margin: auto;
  font-size: 14px;
  line-height: 30px;
  color: #333;
  text-align: center;
}
.zhifus .d2 {
  margin: auto;
  font-size: 14px;
  line-height: 30px;
  color: #333;
  text-align: center;
  padding-bottom: 40px;
}
.shoufu {
  clear: both;
  position: relative;
  display: block;
  width: 1120px;
  height: 220px;
  margin: 0 auto;
  background-repeat: no-repeat;
  background-size: cover;
  background-image: url("../../assets/images/gm.png");

  margin-bottom: 40px;
}
.shoufu .d1 {
  position: relative;
  font-family: PingFangSC-Medium;
  font-size: 17px;
  color: #e9c786;
  letter-spacing: 0;
  line-height: 24px;
  vertical-align: middle;
  text-align: center;
  padding: 50px 0;
}
.shoufu .d2 {
  display: block;
  width: 180px;
  height: 36px;
  bottom: 22px;
  margin: auto;
  background: #d4b777;
  background: linear-gradient(144deg, #ffe8b1, #d4b777) no-repeat;
  box-shadow: 0 3px 17px 0 rgb(220 192 129 / 20%);
  border-radius: 25px;
  font-family: PingFangSC-Semibold;
  font-size: 16px;
  color: #64400e;
  letter-spacing: 0;
  text-align: center;
  line-height: 36px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/personCenter/memberCenter.vue